import { PersonBus } from './PersonBus';
import { BaseBus } from './BaseBus';

export class PersonNotesBus extends BaseBus 

{
    constructor(data: PersonNotesBus = null) {
    super(data);
    if (data != null) {
      this.personNoteId = data.personNoteId;
      this.personId = data.personId;
      this.personNotePersonId = data.personNotePersonId;
      this.note = data.note;
      this.insertUserid = data.insertUserid;
      this.insertDt = new Date(data.insertDt);
      this.updateUserId = data.updateUserId;
      this.updateDt = new Date(data.updateDt);
      this.personNotePerson = data.personNotePerson;
    }
  }
  personNoteId: any;
  personId: any;
  personNotePersonId: any;
  note: string;
  insertUserid: any;
  insertDt: Date;
  updateUserId: any;
  updateDt: Date;
  personNotePerson: PersonBus;
}
